/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {isPresent} from '../utils/lang';

@Pipe({name: 'abbreviation'})
export class AbbreviationPipe implements PipeTransform {
  public transform(value: any): any {
    if (!isPresent(value)) {
      return;
    }

    const words: string[] = value.split(' ');
    return `${words[0][0]}${words[1] ? words[1][0] : ''}`.toUpperCase();
  }
}
